import React from 'react';
import ButtonStyle from './style';

const Button = () => {
  return <ButtonStyle>Get extension</ButtonStyle>;
};

export default Button;
